import { render, staticRenderFns } from "./InquiryOrderModal.vue?vue&type=template&id=0591295a&scoped=true"
import script from "./InquiryOrderModal.vue?vue&type=script&lang=js"
export * from "./InquiryOrderModal.vue?vue&type=script&lang=js"
import style0 from "./InquiryOrderModal.vue?vue&type=style&index=0&id=0591295a&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0591295a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/www/wwwroot/chaoangoods.com/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0591295a')) {
      api.createRecord('0591295a', component.options)
    } else {
      api.reload('0591295a', component.options)
    }
    module.hot.accept("./InquiryOrderModal.vue?vue&type=template&id=0591295a&scoped=true", function () {
      api.rerender('0591295a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/inquiryCenter/InquiryOrderModal.vue"
export default component.exports